module.exports = __webpack_public_path__ + "img/multiseason2.8f425af7.png";